import { useState } from 'react';

import { ColumnConfigurationRenderAs } from '@april9au/stack9-sdk';
import * as ui from '@april9au/stack9-ui';

import { EntityDrawer } from '../../components/EntityDrawer/EntityDrawer';
import { ListTable } from '../../components/ListTable/ListTable';
import { AppRoutes } from '../../constants/appRoutes';
import { entityNames } from '../../constants/entities';
import { EDetailsQueryNames } from '../../constants/queryNames';

type Props = {
  id: number;
};

const Button = ui.S9Button.default;

const { Space, useRefreshList } = ui;
const PartnerUser = ({ id }: Props) => {
  const [isOpen, setIsOpen] = useState(false);
  const refresh = useRefreshList();

  return (
    <ListTable
      queryVars={{
        partnerId: id,
      }}
      queryName="getusersbypartner"
      title="Users"
      columns={[
        {
          label: 'User name',
          field: 'username',
          renderAs: ColumnConfigurationRenderAs.Text,
          value: '{{username}}',
          options: {
            linkProp: '/crm/user/{{id}}',
          },
        },
        {
          label: 'First name',
          field: 'first_name',
          renderAs: ColumnConfigurationRenderAs.Text,
          value: '{{first_name}}',
        },
        {
          label: 'Last name',
          field: 'last_name',
          renderAs: ColumnConfigurationRenderAs.Text,
          value: '{{last_name}}',
        },
        {
          label: 'Email',
          field: 'email',
          renderAs: ColumnConfigurationRenderAs.Text,
          value: '{{email}}',
        },
        {
          label: 'Phone',
          field: 'phone',
          renderAs: ColumnConfigurationRenderAs.Text,
          value: '{{phone}}',
        },
        {
          label: 'Position',
          field: 'position',
          renderAs: ColumnConfigurationRenderAs.Text,
          value: '{{position}}',
        },
        {
          label: 'Default language',
          field: 'default_language',
          renderAs: ColumnConfigurationRenderAs.Text,
          value: '{{default_language}}',
        },
        {
          label: 'User groups',
          field: 'user_groups',
          value: '{{user_groups.map(item=>item.name)}}',
          renderAs: ColumnConfigurationRenderAs.EnumTags,
        },
        {
          label: 'Invited by',
          field: 'invited_by_user',
          renderAs: ColumnConfigurationRenderAs.Text,
          value: '{{invited_by_user.full_name}}',
        },
        {
          label: 'Created at',
          field: '_created_at',
          renderAs: ColumnConfigurationRenderAs.Date,
          value: '{{_created_at}}',
          options: {
            noTime: true,
          },
        },
      ]}
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'end',
          marginBottom: '15px',
        }}
      >
        <EntityDrawer
          open={isOpen}
          title="user"
          initialValues={{
            partner_id: id,
          }}
          entityName={entityNames.USER}
          formFields={[
            'first_name',
            'last_name',
            'username',
            'email',
            'phone',
            'is_active',
            'job_title',
            'user_groups',
            'account_id',
            'position',
            'default_language',
            'partner_id',
            'security_role_id',
          ]}
          relativePath={AppRoutes.PartnerDetail}
          screenQueryName={EDetailsQueryNames.GetUserDetailsCRM}
          editRoute={AppRoutes.UserDetail}
          onClose={() => {
            setIsOpen(false);
            refresh();
          }}
        />
        <Space>
          <Button
            label="Create"
            onClick={() => setIsOpen(true)}
            type="primary"
          />
        </Space>
      </div>
    </ListTable>
  );
};

export default PartnerUser;
